import StackStateBadge from "components/StackStateBadge";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { SpaceDetailsStack } from "../types";

const SpaceDetailsStacksStateCell = ({
  item: stack,
  ...cellProps
}: TableSimpleCellProps<SpaceDetailsStack>) => (
  <TableSimpleCell {...cellProps}>
    <StackStateBadge state={stack.state} />
  </TableSimpleCell>
);

export default SpaceDetailsStacksStateCell;
